import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { AzureAdSettings, OutlookSettings } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: OutlookSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: OutlookSettings;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors, watch } = useForm<OutlookSettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    shouldUnregister: true,
    defaultValues: props.data,
  });

  const renderClientSecret = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Client Secret</label>
          <Controller
            control={control}
            rules={{
              required: 'Client Secret is required',
            }}
            name="clientSecret"
            defaultValue={props.data?.clientSecret}
            render={({ onChange, value, name }) => (
              <input
                type="password"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Client Secret"
                name={name}
                value={value}
                onChange={onChange}
                id="clientSecret"
              />
            )}
          />
          <ErrorMessage>{errors.clientSecret?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderClientId = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Client ID</label>
          <Controller
            control={control}
            rules={{
              required: 'Client ID is required',
            }}
            name="clientId"
            defaultValue={props.data?.clientId}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Client ID"
                name={name}
                value={value}
                onChange={onChange}
                id="clientId"
              />
            )}
          />
          <ErrorMessage>{errors.clientId?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderTenantId = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Tenant ID</label>
          <Controller
            control={control}
            rules={{
              required: 'Tenant ID is required',
            }}
            name="tenantId"
            defaultValue={props.data?.tenantId}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Tenant ID"
                name={name}
                value={value}
                onChange={onChange}
                id="tenantId"
              />
            )}
          />
          <ErrorMessage>{errors.tenantId?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">Update Outlook  Settings</h4>
        <div className="row gutter-10">
          {renderTenantId()}
          {renderClientId()}
          {renderClientSecret()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
